import { connect } from 'react-redux';
import autobind from 'core-decorators/lib/autobind';

import { getVideoById, isFetching } from 'shared/selectors/videos';
import { getPublic as getVideo } from 'shared/redux/server/actions/channel/video/get';

import DataLoader from 'shared/data-components/_data-loader';


@connect((state, ownProps) => ({
  channelVideoData: getVideoById(state, ownProps.videoId),
  isFetching: isFetching(state),
}), {
  getVideo,
})
export default class ChannelVideoLoader extends DataLoader {

  static displayName = 'ChannelVideoLoader';
  static propTypes = {
    channelVideoData: React.PropTypes.object,
    getVideo: React.PropTypes.func,
    channelId: React.PropTypes.string,
    videoId: React.PropTypes.string,
    lazyChannelVideos: React.PropTypes.object,
  };

  dependencies = [
    'channelId',
    'videoId',
  ];

  loadData(forceLoad) {
    const { channelId, videoId, getVideo, channelVideoData } = this.props;

    if (!channelId || !videoId) {
      return;
    }

    if (channelVideoData && !forceLoad) {
      return Promise.resolve(channelVideoData);
    }

    return getVideo(channelId, videoId);
  }

  @autobind
  forceFetch() {
    this.loadDataDebounced(true);
  }

  get childProps() {
    const { channelVideoData, isFetching } = this.props;
    return {
      channelVideoData,
      channelVideo: { isFetching, fetch: this.forceFetch },
    };
  }

}



// WEBPACK FOOTER //
// ./src/widget/data-components/channel-video.js